import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {SalutationsActions} from '../store';
import {SalutationsSelectors} from '../store/selectors';

@Injectable()
export class SalutationsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadSalutationsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadSalutationsDone() {

    return this.store.pipe(
      select(SalutationsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(SalutationsActions.ReadSalutations());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
